import { render, staticRenderFns } from "./COMBAT_BASEINFOR.vue?vue&type=template&id=5b829aea&scoped=true"
import script from "./COMBAT_BASEINFOR.vue?vue&type=script&lang=js"
export * from "./COMBAT_BASEINFOR.vue?vue&type=script&lang=js"
import style0 from "./COMBAT_BASEINFOR.vue?vue&type=style&index=0&id=5b829aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b829aea",
  null
  
)

export default component.exports